import { gql } from '@apollo/client';

export const GET_REFERRER_CODE = gql`
  query getReferrerCode {
    getReferrerCode {
      referralCode
    }
  }
`;
